// components/SkeletonBlogCard.jsx
import Skeleton from "react-loading-skeleton";

// Skeleton card component for blog post
const SkeletonBlogCard = () => {
  return (
    <li className="blog-post-item">
      <a href="#!" aria-disabled="true">
        <figure className="blog-banner-box">
          {/* Image placeholder with shimmer */}
          <Skeleton height={200} borderRadius={8} />
        </figure>

        <div className="blog-content mt-4 space-y-3">
          {/* Meta placeholders */}
          <div className="flex items-center gap-2">
            <Skeleton width={60} height={16} />
            <span className="dot"></span>
            <Skeleton width={80} height={16} />
          </div>

          {/* Title placeholder */}
          <Skeleton width="75%" height={22} />

          {/* Description placeholders */}
          <Skeleton count={2} height={16} />
        </div>
      </a>
    </li>
  );
};

export default SkeletonBlogCard;
